// Vuex
import store from '@/store.js';

import Request from './request';

async function fetchAll() {
  return Request('get', "api/districts");
}

async function tree() {
    const response = await Request('get', "api/districts/tree");
    if (response.data && response.data.status.isOK()) {
        store.commit("serverDistricts", response.data.districts);
    }
    return response;
}

async function save(id, data) {
  if (id) {
    return Request('post', "api/districts/edit?id=" + id, data);
  } else {
    return Request('post', "api/districts/add", data);
  }
}

async function del(id) {
  return Request('get', "api/districts/delete/", id ? { id: id } : {});
}

export default {
  fetchAll,
  tree,
  save,
  del,
};